import React, { useContext, useEffect, useMemo, useState } from "react";

import './GrillasStyles.css'; //Con importar los estilos de grillas aqui, ya queda aplicado para GrillaDocumentos y GrillaProcsProgramados.
import controlContext from "../../context/control/controlContext";
import authContext from "../../context/authentication/authContex";
import informesContext from "../../context/informesContext/informesContext";
import { STATES, ALERTSProcedimientosProgramados, TIPPROCS, STATESProcsProgramados, ORIGENES, CHECKLISTStates } from "../../utils/states";
import { filtrosToString } from "../../utils/funciones";
import { getTDocsByUserIdAndParamsReport } from "../../api/transactionDocuments";
import { getUsersInGroupV } from "../../api/user";
import normalizeText from "../../utils/normalizeText";

//Iconos
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  faArrowLeftLong,
  faDownload,
  faTableCells
} from "@fortawesome/free-solid-svg-icons";
import SearchInput from "../searchInput/SearchInput";
import AddFilter from "../addFilter/AddFilter";
import FilterScreen from "../filterScreen/FilterScreen";
import usuariosContext from "../../context/usuarios/usuariosContext";
import SelectColumns from "./SelectColumns";
import Table from "./Table";

const COTIZACION_DOLAR_DEFAULT = 1500;

const formatARS = (valor) => `$${valor.toLocaleString('de-DE', {minimumFractionDigits:0, maximumFractionDigits:0})}`;
const formatUSD = (valor) => `US$${valor.toLocaleString('de-DE', {minimumFractionDigits:2, maximumFractionDigits:2})}`;

const GrillaOrdenesTrabajo = ({setGridToShow}) => {

     // Filtros propios de este reporte: intencionalmente NO se leen/escriben del controlContext
     // (compartido con el Dashboard/Home) para que aplicar un filtro acá no afecte esas vistas.
     const cContext = useContext(controlContext);
     const {
         initialState,
         getProductsByNroFor,
         filtrar
     } = cContext;

     const uContext = useContext(usuariosContext);
     const {userListView, saveColumnsPreferences} = uContext
 
     const aContext = useContext(authContext);
     const { usuario } = aContext;
 
     const iContext = useContext(informesContext);
     const {generarInformeExcel} = iContext;

    let columnsPreferences = useMemo(()=> usuario?.columnsPreferences?.columnasOrdenesTrabajo ?? [], [usuario])

    
    
    const [columns, setColumns] = useState([
        {width: 200, property: 'fecAlt', title: 'Fecha de Alta', visible: true },
        {width: 150, property: 'fechaCompletado', title: 'Fecha Completada', visible: true },
        {width: 100, property: 'tDocCodFor', title: 'Código', visible: true },
        {width: 100, property: 'tDocNroFor', title: 'Número', visible: true },
        {width: 275, property: 'title', title: 'Título', visible: true },
        {width: 650, property: 'observ', title: 'Observaciones', visible: true },
        {width: 75, property: 'priorityString', title: 'Criticidad', visible: true },
        {width: 100, property: 'state', title: 'Estado', visible: true },
        {width: 50, property: 'tareas', title: 'Tareas', visible: true, totalizator: true, value: 0 },
        {width: 150, property: 'codActivo', title: 'Código Activo', visible: true },
        {width: 250, property: 'activo', title: 'Activo', visible: true },
        {width: 200, property: 'tipoActivo', title: 'Tipo de Activo', visible: true },
        {width: 150, property: 'codProc', title: 'Código Procedimiento', visible: true },
        {width: 250, property: 'procedimiento', title: 'Procedimiento', visible: true },
        {width: 150, property: 'tipoProcedimiento', title: 'Tipo Procedimiento', visible: true },
        {width: 150, property: 'imputaciones', title: 'Imputaciones RRHH', visible: true },
        {width: 150, property: 'cantHorasRRHH', title: 'Cantidad Horas RRHH', visible: true, totalizator: true, value: 0},
        {width: 200, property: 'valorRRHHString', title: 'Valor Imputaciones RRHH', visible: true, totalizator: true, value: 0 },
        {width: 100, property: 'products', title: 'Materiales', visible: true },
        {width: 150, property: 'valorMaterialesString', title: 'Valor Materiales', visible: true, totalizator: true, value: 0 },
        {width: 150, property: 'valorMaterialesUSDString', title: 'Valor Materiales USD', visible: true, totalizator: true, value: 0 },
        {width: 200, property: 'proveedores', title: 'Serv. de Terceros', visible: true },
        {width: 150, property: 'valorProveedoresString', title: 'Valor Serv. Terceros', visible: true, totalizator: true, value: 0 },
        {width: 180, property: 'valorTotalString', title: 'Valor Total', visible: true, totalizator: true, value: 0 },
        {width: 200, property: 'notePubl', title: 'Nota Pública', visible: true },
        {width: 100, property: 'userName', title: 'Usuario', visible: true },
    ]);    
    
    const [permantentOTs,setPermanentOTs] = useState(undefined);
    const [OTsFiltered,setOTsFiltered] = useState(permantentOTs);
    const [filter,setFilter] = useState('');
    const [showFilters,setShowFilter] = useState(false);
    const [showSelectColumns,setShowSelectColumns] = useState(false);
    const [selectedFilter, setSelectedFilter] = useState("");
    const [activeWorkSpace, setActiveWorkSpace] = useState({todos: 1, pendientes: 0, disponibles:0 });
    const [selct,setSelec] = useState([])
    const [loading,setLoading] = useState(false);

    // Estado de filtros local al reporte (no vive en controlContext).
    const [filtrosRango, setFiltrosRango] = useState(initialState.filtrosRango);
    const [filtrosEstado, setFiltrosEstado] = useState(initialState.filtrosEstado);
    const [reporteData, setReporteData] = useState(undefined);
    const [hasFetched, setHasFetched] = useState(false);
    const [cotizacionDolar, setCotizacionDolar] = useState(COTIZACION_DOLAR_DEFAULT);

    // Arma los valores por defecto del filtro (usuarios visibles, activos permitidos, etc.)
    // sin pegarle todavía al backend por los datos del informe: eso recién ocurre al presionar "Aplicar Filtros".
    const handlerIniciarlizarFiltros = async () => {
        try {
            const respUsuarios = await getUsersInGroupV(usuario._id);
            const usuarios = [...new Set(respUsuarios.data.data.map((u) => u.user.userName))];
            if (!usuarios.includes(usuario.userName)) usuarios.push(usuario.userName);

            setFiltrosEstado(prev => ({
                ...prev,
                state: STATES,
                tipoAlerta: ALERTSProcedimientosProgramados,
                tipoProcedimientos: TIPPROCS,
                statesProcedimientos: STATESProcsProgramados,
                origenes: ORIGENES,
                statesChecklist: CHECKLISTStates,
                userName: usuarios,
                tipoActivos: [],
                activos: usuario.activosAllowed.map(a => a.value),
            }));
        } catch (error) {
            console.log(error);
        }
    }

    const handleGenerarInforme = async() =>{
        let dataToExcel = []; //Arreglo que contendra tanto el Header del excel como las Filas Hijas de Informacion.
        let columnsTitle = columns.filter(c => c.visible).map(c => c.title); //Arreglo que contiene el nombre de las columnas o header.
        dataToExcel.push(columnsTitle); //Se pushea la primer fila del excel.

        //Por cada OT filtrada se crea un array nuevo, a este se le pushearan las propiedades que hayan sido especificadas en la visualizacion del informe en el frontend.
        for(const o of OTsFiltered){
            let otModelado = [];
            for(const col of columns){
                if(!col.visible) continue;
                (Array.isArray(o[col.property])) ? otModelado.push(o[col.property].length) : (col.property == 'fecAlt' || col.property == 'fechaCompletado') ? otModelado.push(o[col.property] ? o[col.property].toString().substring(0,10) : '') : (col.property == 'valorMaterialesString') ?  otModelado.push(o["valorMateriales"]) : (col.property == 'valorMaterialesUSDString') ?  otModelado.push(o["valorMaterialesUSD"]) : (col.property == 'valorRRHHString') ?  otModelado.push(o["valorRRHH"]) : (col.property == 'valorProveedoresString') ? otModelado.push(o["valorProveedores"]) : (col.property == 'valorTotalString') ?  otModelado.push(o["valorTotal"]) : otModelado.push(o[col.property]);
            }
            if(otModelado.length > 0) dataToExcel.push(otModelado); //Si algun campo coincidio lo pushea a dataToExcel para ser impresa en el .xlsx.
        }
        await generarInformeExcel(dataToExcel, 'OrdenesTrabajo'); //Viaja hacia la funcion del contexto para ser generado el xlsx.
    }


    const handleChangeColumnsVisible = (e, c, i) =>{
        setColumns((prevCols) => prevCols.map((c,index) => index == i ? {...c, visible: e.target.checked} : c))
    }

    const handlerClickFilter = (itm) => {
        setShowFilter(false)
    }

    // Al presionar "Aplicar Filtros" en el modal se pide el informe al backend, usando la misma
    // ruta de reporte que ya se usaba, en vez de depender del listado del controlContext.
    const apFiltros = async (filtrosProp) => {
        setFiltrosEstado({ ...filtrosProp.filterEstado });
        setFiltrosRango(filtrosProp.filterRango);
        setLoading(true);
        try {
            const filtrosString = filtrosToString(filtrosProp.filterRango);
            const resp = await getTDocsByUserIdAndParamsReport(usuario._id, filtrosString);
            setReporteData(resp.data.data);
            setHasFetched(true);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    //resFiltered llega como referencia al array, por lo que al recorrerlo y modificar los objetos presentes dentro de el, estamos modificando directamente el arreglo original, evitando asi tener que retornar el arreglo modificado.
    const modelateTable = (resFiltered) => {
            let valorImputacionesTotal = 0;
            let valorProveedoresTotal = 0;
            let valorMaterialesTotal = 0;
            let valorMaterialesUSDTotal = 0;
            // Todos los precios estan en pesos; el valor en USD es solo informativo. Si el input queda vacío o en 0 se usa la cotización por defecto, para no dividir por cero.
            const cotizacion = Number(cotizacionDolar) > 0 ? Number(cotizacionDolar) : COTIZACION_DOLAR_DEFAULT;
            let valorTotalTotal = 0;
            let horasTotal = 0;
            let cantTareas = 0;
            if(resFiltered){
                for(const ot of resFiltered){
                    let valorImputaciones = 0;
                    let valorMateriales = 0;
                    let valorProveedores = 0;
                    let cantHorasRRHH = 0;

                    cantTareas += ot.tareas.length;
                    
                    ot.imputaciones.forEach(l => {
                        let {basico, basicoHora, adicional} = l.legajo;

                        let valorLinea = l.cantHoras * basicoHora;
                        valorImputaciones += isNaN(valorLinea) ? 0 : valorLinea;
                        cantHorasRRHH += l.cantHoras
                    });
                    valorImputaciones = Math.round(valorImputaciones);
                    valorImputacionesTotal += valorImputaciones;
                    horasTotal += cantHorasRRHH;

                    let valorImputacionesString = valorImputaciones.toLocaleString('de-DE',{
                        minimumFractionDigits:0,
                        maximumFractionDigits:0
                    })
                    ot.valorRRHH = valorImputaciones;
                    ot.valorRRHHString = `$${valorImputacionesString}`;
                    ot.cantHorasRRHH = cantHorasRRHH;
                
                    ot.proveedores.forEach(p => {
                        let {importe} = p;
                        valorProveedores += isNaN(importe) ? 0 : importe;
                    })
                    let valorProveedoresString = valorProveedores.toLocaleString('de-DE',{
                        minimumFractionDigits:0,
                        maximumFractionDigits:0
                    })
                    valorProveedores = Math.round(valorProveedores);
                    valorProveedoresTotal += valorProveedores;
                    ot.valorProveedores = valorProveedores;
                    ot.valorProveedoresString = `$${valorProveedoresString}`;

                    ot.products.forEach(p => {
                        let valorLinea = p.quantity * ((p.precio == undefined) ? 0 : p.precio);
                        valorMateriales += isNaN(valorLinea) ? 0 : valorLinea;
                    });
                    valorMateriales = Math.round(valorMateriales);
                    valorMaterialesTotal += valorMateriales;
                    ot.valorMateriales = valorMateriales;
                    ot.valorMaterialesString = formatARS(valorMateriales);
                    const valorMaterialesUSD = Math.round(valorMateriales / cotizacion * 100) / 100;
                    valorMaterialesUSDTotal += valorMaterialesUSD;
                    ot.valorMaterialesUSD = valorMaterialesUSD;
                    ot.valorMaterialesUSDString = formatUSD(valorMaterialesUSD);

                    let valorTotal = valorImputaciones + valorMateriales + valorProveedores;
                    valorTotalTotal += valorTotal;
                    let valorTotalString = valorTotal.toLocaleString('de-DE',{
                        minimumFractionDigits:0,
                        maximumFractionDigits:0
                    })
                    ot.valorTotal = valorTotal;
                    ot.valorTotalString = `$${valorTotalString}`;

                    setColumns(prevCols => {
                        prevCols.forEach(pC => {
                            switch(pC.property){
                                case "tareas":
                                    pC.value = cantTareas;
                                    break;
                                case "cantHorasRRHH":
                                    pC.value = horasTotal;
                                    break;
                                case "valorRRHHString":
                                    pC.value = `$${valorImputacionesTotal.toLocaleString('de-DE', {
                                        minimumFractionDigits:0,
                                        maximumFractionDigits:0
                                    })}`;
                                    break;
                                case "valorProveedoresString":
                                    pC.value = `$${valorProveedoresTotal.toLocaleString('de-DE', {
                                        minimumFractionDigits:0,
                                        maximumFractionDigits:0
                                    })}`;
                                    break;
                                case "valorMaterialesString":
                                    pC.value = `$${valorMaterialesTotal.toLocaleString('de-DE', {
                                        minimumFractionDigits:0,
                                        maximumFractionDigits:0
                                    })}`;
                                    break;
                                case "valorMaterialesUSDString":
                                    pC.value = formatUSD(valorMaterialesUSDTotal);
                                    break;
                                case "valorTotalString":
                                    pC.value = `$${valorTotalTotal.toLocaleString('de-DE', {
                                        minimumFractionDigits:0,
                                        maximumFractionDigits:0
                                    })}`;
                                    break;
                            }
                        })
                    return prevCols;
                    })
                }
            }else{
                return undefined
            }

    }

    // Al visitar el reporte se abre directamente el modal de filtros (sin disparar la búsqueda
    // pesada por defecto), para que el usuario elija el rango antes de pedir los datos.
    useEffect(() => {
        const fn = async() =>{
            await handlerIniciarlizarFiltros();
            setShowFilter(true);
        }
        fn();
    },[]);

    useEffect(()=>{
        if(!hasFetched) return;
        if(filter != ''){
            const nFilter = normalizeText(filter);
            let OTs = permantentOTs.filter(r => normalizeText(r.title).includes(nFilter) || normalizeText(r.tDocNroFor.toString()).includes(nFilter) || normalizeText(`${r.tDocCodFor} - ${r.tDocNroFor}`).includes(nFilter));
            modelateTable(OTs);
            setOTsFiltered(OTs);
        }else if(reporteData){
            let OTs = permantentOTs;
            modelateTable(OTs);
            setOTsFiltered(OTs);
        }
    },[filter]);

    useEffect(() => {
        if(!hasFetched) return;
        let reporteDataCopy = (reporteData == undefined) ? undefined : reporteData.slice();
        let resFiltered = filtrar(reporteDataCopy, filtrosEstado, undefined, 'ReportesODT')
        if(reporteDataCopy){
            modelateTable(resFiltered);
            setPermanentOTs(resFiltered);
            setOTsFiltered(resFiltered);
        }
        else{
            setPermanentOTs(undefined);
            setOTsFiltered(undefined);
        }
    }, [reporteData, filtrosEstado, hasFetched])

    //Al cambiar la cotización se recalculan los valores en USD sobre las ODTs ya cargadas.
    useEffect(()=>{
        if(!hasFetched || !OTsFiltered) return;
        modelateTable(OTsFiltered);
        setOTsFiltered([...OTsFiltered]);
    },[cotizacionDolar]);

    useEffect(()=>{
        if(columnsPreferences && columnsPreferences.length > 0){
            setColumns(prevColumns => prevColumns.map(c => ({...c, visible: columnsPreferences.includes(c.property)})))
        }
    },[columnsPreferences])


    return <div className="grillaInformeDiv">
        <div className="utilitiesDiv">
            <button onClick={()=>setGridToShow('')} className="goBackBtn"><FontAwesomeIcon className="iconArrowBack" icon={faArrowLeftLong}/></button>
            <SearchInput filter={filter} buscar={setFilter}/>
            <FilterScreen verFiltro={setShowFilter}/>
            <div className="cotizacionDolarDiv">
                <label htmlFor="cotizacionDolar">Cotización USD</label>
                <input id="cotizacionDolar" type="number" min="0" value={cotizacionDolar} onChange={(e)=>setCotizacionDolar(e.target.value)}/>
            </div>
            <button className="selectColumnsBtn" onClick={()=>setShowSelectColumns(true)}><FontAwesomeIcon className="iconArrowBack" icon={faTableCells}/></button>
            <button disabled={loading || OTsFiltered == undefined || OTsFiltered.length == 0} className="downloadBtn" onClick={handleGenerarInforme}>Descargar .xlsx <FontAwesomeIcon className="iconArrowBack" icon={faDownload}/></button>
        </div>
        {
            loading ? <h3 className="warningStatusMsg">Cargando sus ordenes de trabajo<span>.</span><span>.</span><span>.</span></h3>
                : !hasFetched ? <h3 className="warningStatusMsg">Seleccione los filtros y presione "Aplicar Filtros" para generar el informe</h3>
                : (OTsFiltered == undefined) ? <h3 className="warningStatusMsg">Cargando<span>.</span><span>.</span><span>.</span></h3>
                : (OTsFiltered.length == 0) ? <h3 className="warningStatusMsg">No hay ordenes de trabajo cargadas</h3>
                : <Table array={OTsFiltered} columns={columns} setColumns={setColumns}/>
        }
        {
            showSelectColumns && <SelectColumns setShowSelectColumns={setShowSelectColumns} handleChangeColumnsVisible={handleChangeColumnsVisible} columns={columns} saveColumnsPreferences={saveColumnsPreferences} usuario={usuario} columnsName={"OrdenesTrabajo"}/>
        }
        {showFilters &&
                <div className="addFilterContainer">
                    <AddFilter
                        usuarios={userListView} 
                        item={selectedFilter} 
                        cerrar={handlerClickFilter} 
                        filtro={{filtrosRango, filtrosEstado}} 
                        aplicarFiltros={apFiltros} 
                        workspace={activeWorkSpace} 
                        selct={selct}
                        setSelec={setSelec}
                        componentePadre="ReportesODT"
                    />
                </div>
            }
    </div>
}

export default GrillaOrdenesTrabajo;